import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { ColorConfigurationSelect } from '../inputs/ColorConfigurationSelect';
import { optionFilterBySystemAndClass } from '../inputs/ConfigurationSelect';
import { PaintColorValue } from '../readonly/PaintColorValue';
import { ConfigurationComponent } from '.';

const RainGuardInput = () => (
  <ColorConfigurationSelect
    configurationKey="rainGuardColor"
    dispatchAction="SET_RAIN_GUARD"
    optionsFilterFn={optionFilterBySystemAndClass}
  />
);

const config: ConfigurationComponent<'rainGuardColor'> = {
  key: 'rainGuardColor',
  input: <RainGuardInput />,
  display: (value: ConfigurationValues['rainGuardColor']) => (
    <PaintColorValue value={value} />
  ),
};

export default config;
